// Dummy loader for core modules used by components.
//
// Components load core modules as core!module/name
// and the component build is structured so that no modules
// prefixed with core! will be minified.
define('core',[
    'services/loggingService'
], function (loggingService) {
    'use strict';
    return {
        load: function (name, require, onload /*config*/) {
            require([name], function (value) {
                onload(value);
            }, function (error) {
                loggingService.error('Component requested invalid core module: ' + name, error);
                // This will either stop the component from loading or create
                // an issue at runtime, but at least it won't stop the app from loading.
                onload(null);
            });
        }
    };
});

